<div>
  <div class="modal-header">
    <h5 class="modal-title"
        id="rebootDevicesModalLabel">Select devices to reboot</h5>
    <button type="button"
            class="btn-close"
            aria-label="Close"
            (click)="closingModal()"></button>
  </div>
  <div class="modal-body">
    <div class="d-flex p-2 bd-highlight">
      <form [formGroup]="rebootDevicesForm">
        <div class="alert alert-info p-2 d-flex align-items-center gap-3"
             role="alert">
          <fa-icon [icon]="['fas', 'circle-info']"
                   class="flex-shrink-0"
                   aria-hidden="true"></fa-icon>
          <span class="flex-grow-1">{{ rebootScopeMessage() }}</span>
        </div>
        Please select which device types to reboot.<br />
        <br />

        <div class="form-check">
          <input class="form-check-input"
                 formControlName="AppleTV"
                 type="checkbox"
                 id="AppleTV" />
          <label class="form-check-label"
                 for="AppleTV"> AppleTV </label>
        </div>
        <div class="form-check">
          <input class="form-check-input"
                 formControlName="iPad"
                 type="checkbox"
                 id="iPad" />
          <label class="form-check-label"
                 for="iPad"> iPad </label>
        </div>
        <div class="form-check">
          <input class="form-check-input"
                 formControlName="iPhone"
                 type="checkbox"
                 id="iPhone" />
          <label class="form-check-label"
                 for="iPhone"> iPhone </label>
        </div>
        <div class="form-check">
          <input class="form-check-input"
                 formControlName="iPod"
                 type="checkbox"
                 id="iPod" />
          <label class="form-check-label"
                 for="iPod"> iPod </label>
        </div>
        @if (rebootDevicesForm.invalid) {
          <div class="text-danger">* Please select at least one device model.</div>
        }
      </form>
    </div>
  </div>
  <div class="modal-footer">
    <button type="button"
            class="btn btn-secondary"
            (click)="closingModal()">Close</button>
    <button type="button"
            [disabled]="rebootDevicesForm.invalid"
            class="btn btn-primary"
            (click)="onSubmit()">
      Reboot devices
    </button>
  </div>
</div>